import clsx from "clsx"
export default function Transcript({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-(--space-7) h-auto')} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5998 14.4H14.3998V16.8H9.5998V14.4Z" fill="#38362D"/>
      <path d="M14.3998 9.60002H9.5998V12H14.3998V9.60002Z" fill="#38362D"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.5998 2.40002L19.1998 6.00002V21.6H4.7998V2.40002H15.5998ZM7.1998 4.80002H14.3998V7.20002H16.7998V19.2H7.1998V4.80002Z" fill="#38362D"/>
    </svg>
  )
}
